import { render, staticRenderFns } from "./MpProgress.vue?vue&type=template&id=605401b4&"
import script from "./MpProgress.vue?vue&type=script&lang=js&"
export * from "./MpProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports